import { render, staticRenderFns } from "./ModalBase3.vue?vue&type=template&id=1c8072d4&scoped=true&"
import script from "./ModalBase3.vue?vue&type=script&lang=ts&"
export * from "./ModalBase3.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBase3.vue?vue&type=style&index=0&id=1c8072d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8072d4",
  null
  
)

export default component.exports